import { ChrModal } from '@chr/web-components';
import { AppState } from '../../../app-state';
import React from 'react';
import { connect } from 'react-redux';
import { Action } from 'redux';
import { errorModalClose } from '../../../common/actions/errorModalActions';

export interface ErrorModalProps {
  errorModalOpen: boolean;
  errorModalClose(): Action;
}

export class ErrorModal extends React.Component<ErrorModalProps> {

  render() {
    if (this.props.errorModalOpen) {
      return (
        <ChrModal
          title="OUR SYSTEM IS HAVING TECHNICAL DIFFICULTIES"
          primaryButtonProps={{
            buttonClicked: this.props.errorModalClose,
            text: 'Close'
          }}
        >
          <div>
            There is an error with our system. Please try again shortly.
            <br />
            <hr />
            For immediate assistance, please contact your representative or call 1-800-316-8122.
          </div>
        </ChrModal>
      );
    }
    return null;
  }
}

const mapStateToProps = (state: AppState) => ({
  errorModalOpen: state.error.errorModalOpen
});

export const mapDispatchToProps = dispatch => ({
  errorModalClose: () => dispatch(errorModalClose())
});

export default connect(mapStateToProps, mapDispatchToProps)(ErrorModal);
